import { useControlledSearchInput } from '@deltasierra/react-hooks';
import * as React from 'react';
import { t } from '@deltasierra/shared';
import { DSTextField } from '../../../mui';
import { AssetShareTargetCheckbox } from '../AssetShareTargetCheckbox';
import { PickableClientOrLocation } from './types';

export type ClientPickerProps = {
    clients: ReadonlyArray<PickableClientOrLocation>;
    selected: ReadonlyArray<string>;
    disabled?: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
    onSearchTermChange?: (newTerm?: string) => void;
};

export const ClientPicker: React.FC<ClientPickerProps> = ({
    clients,
    disabled = [],
    onChange,
    onSearchTermChange,
    selected,
}) => {
    const { inputProps, searchTerm } = useControlledSearchInput({
        initialValue: '',
        interval: 250,
        onSearchTermValueChange: onSearchTermChange,
    });

    return (
        <>
            <DSTextField fullWidth label={t('COMMON.FILTER')} variant="outlined" {...inputProps} />
            {clients
                .filter(client => client.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
                .map(client => (
                    <AssetShareTargetCheckbox
                        disabled={disabled}
                        item={client}
                        key={client.id}
                        selected={selected}
                        onChange={onChange}
                    />
                ))}
        </>
    );
};
ClientPicker.displayName = 'ClientPicker';
